export const backUri = "https://api.sandbox.vigicard.app/api/v1"
export const tezosUri = "https://tezos.sandbox.vigicard.app"